// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 757 ? "maplibre-gl" : chunkId) + "." + {"358":"368cd95d","757":"17d75cd2","763":"886512e3"}[chunkId] + ".chunk.js";
};